import AxiosInstance from "../services/networkServices";

export const previewBanUser = async (username) => {
  const response = await AxiosInstance.post("/admin/ban-user/preview", {
    username,
  });
  return response.data;
};

export const banUser = async (username, { durationDays, reason } = {}) => {
  const response = await AxiosInstance.post("/admin/ban-user", {
    username,
    ...(durationDays ? { durationDays } : {}),
    reason,
  });
  return response.data;
};

export const unbanUser = async (username) => {
  const response = await AxiosInstance.post("/admin/unban-user", { username });
  return response.data;
};
